import { COUNTRY_CODE, REGION_CODE } from "./constants";

export const costDisplayRules = ({ 

    recyclingCost = 0, 
    logisticsCost = 0, 
    reportingCost = 0, 
    packagingCost = null, 
    consolidationCost = null, 
    totalCost = 0, 
    weight = 0,
    currencyCode = "",
    appMessages = null,
    region = REGION_CODE,
    orderStatus = "",
    showReportingCost = true, 
    showPackagingCost = true, 
    showConsolidationCost = true,
    shippingProvided = false 

} = {}) => {
    
    const AMS = region === "AMS";
    const EMEA = region === "EMEA";
    const APJ = region === "APJ";
    const WEIGHT = parseFloat(weight);
    const NO_CHARGE = appMessages ? appMessages["checkout.summary.item.noCharge"] : "NO CHARGE";
    const TBD_DISCLAIMER = appMessages ? appMessages["checkout.summary.item.costDisclaimer"] : "TBD";
    const ORDER_COMPLETED = orderStatus === "COMPLETED";

    let showCostDisclaimer = false;
    
    let recyclingCostData = {
        show: true,
        value: NO_CHARGE,
        rawValue: recyclingCost,
        type: "recyclingCost"
    };

    let logisticsCostData = {
        show: true,
        value: getFormattedCost({currency: currencyCode, cost: logisticsCost}),
        rawValue: logisticsCost,
        type: "logisticsCost"
    };

    let reportingCostData = {
        show: showReportingCost === true,
        value: getFormattedCost({currency: currencyCode, cost: reportingCost}),
        rawValue: reportingCost,
        type: "reportingCost"
    };

    let packagingCostData = {
        show: showPackagingCost === true,
        value: getFormattedCost({currency: currencyCode, cost: packagingCost}),
        rawValue: packagingCost,
        type: "packagingCost"
    };

    let consolidationCostData = {
        show: showConsolidationCost === true,
        value: getFormattedCost({currency: currencyCode, cost: consolidationCost}),
        rawValue: consolidationCost,
        type: "consolidationCost"
    };

    let totalCostData = {
        show: true,
        value: getFormattedCost({currency: currencyCode, cost: totalCost}),
        rawValue: totalCost,
        type: "totalCost"
    };
    
    if (AMS) {
        if (packagingCostData.rawValue === null) {
            packagingCostData.value = TBD_DISCLAIMER;
        }

        if (consolidationCostData.rawValue === null) {
            consolidationCostData.value = TBD_DISCLAIMER;
        }

        if (WEIGHT < 1000) {
            showCostDisclaimer = true;
            totalCostData.show = totalCostData.rawValue !== 0;

            if (logisticsCostData.rawValue === 0) {
                logisticsCostData.value = shippingProvided ? TBD_DISCLAIMER : NO_CHARGE;
            }

            if (reportingCostData.rawValue === 0) {
                reportingCostData.value = TBD_DISCLAIMER;
            }
        }
        else {
            if (logisticsCostData.rawValue === 0) {
                logisticsCostData.value = NO_CHARGE;
            }
        }
    }

    if (EMEA) {
        if (packagingCostData.rawValue === null) {
            packagingCostData.value = TBD_DISCLAIMER;
        }
        
        if (consolidationCostData.rawValue === null) {
            consolidationCostData.value = TBD_DISCLAIMER;
        }

        if (WEIGHT < 500) { //SUPP2-3710
            if(!shippingProvided){
                logisticsCostData.value =  NO_CHARGE;
            }
        }
        else {
            if (logisticsCostData.rawValue === 0) {
                logisticsCostData.value = NO_CHARGE;
            }
        }
    }

    if (APJ) {
        // Always hide packaging and consolidation costs in APJ
        packagingCostData.show = false;
        consolidationCostData.show = false;

        if (WEIGHT < 500) {
            showCostDisclaimer = true;
            totalCostData.show = totalCostData.rawValue !== 0;

            if (logisticsCostData.rawValue === 0) {
                logisticsCostData.value = shippingProvided ? TBD_DISCLAIMER : NO_CHARGE;
            }
            
            if (reportingCostData.rawValue === 0) {
                reportingCostData.value = TBD_DISCLAIMER;
            }
        }
        else {
            if (logisticsCostData.rawValue === 0) {
                logisticsCostData.value = NO_CHARGE;
            }
        }
    }

    if (AMS) {
        // Always hide packaging and consolidation costs in LAR
        packagingCostData.show = false;
        consolidationCostData.show = false;

        showCostDisclaimer = COUNTRY_CODE === "BR" ? false : true;
        totalCostData.show = totalCostData.rawValue !== 0;
        
        if (reportingCostData.rawValue === 0) {
            reportingCostData.value = TBD_DISCLAIMER;
        }

        if (WEIGHT < 500 && COUNTRY_CODE !== "BR") {
            if (logisticsCostData.rawValue === 0) {
                logisticsCostData.value = shippingProvided ? TBD_DISCLAIMER : NO_CHARGE;
            }
        }
        else {
            if (logisticsCostData.rawValue === 0) {
                logisticsCostData.value = NO_CHARGE;
            }
        }        
    }

    const result = {
        "showDisclaimer": showCostDisclaimer,
        "hideAllCosts": !recyclingCostData.show && !totalCostData.show && !logisticsCostData.show && !reportingCostData.show,
        "recyclingCost": recyclingCostData,
        "logisticsCost": logisticsCostData,
        "reportingCost": reportingCostData,
        "packagingCost": packagingCostData,
        "consolidationCost": consolidationCostData,
        "totalCost": totalCostData,
        "weight": WEIGHT
    }

    return result;

}

function getFormattedCost({currency, cost}) {
    if (!cost) cost = 0;

    const modifiedCost = cost.toFixed(2); 
    return currency ? currency + " " + modifiedCost : modifiedCost;
}
